import { render, staticRenderFns } from "./ServicesReservationTreatmentPlanForm.vue?vue&type=template&id=0f96a25a&scoped=true&"
import script from "./ServicesReservationTreatmentPlanForm.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationTreatmentPlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f96a25a",
  null
  
)

export default component.exports